module.exports = __webpack_public_path__ + "assets/img/3-2.30a4c04d.png";